import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import Layout from "./Layout"

import { media } from "../styles"
import LogoSVG from "../images/logos/blog-logo.inline.svg"

const Logo = styled.div`
  color: ${({ theme }) => theme.spaceblue};
  width: 100px;
  position: relative;
  z-index: 1;

  @media ${media.md} {
    width: 130px;
  }

  svg {
    display: block;
    height: auto;
    width: 100%;
  }
`

const BlogLayout = (props) => {
  return (
    <Layout
      hideLangSwitch={true}
      layout={props.layout}
      logo={
        <Link to="/blog/">
          <Logo>
            <LogoSVG />
          </Logo>
        </Link>
      }
      pageId={props.pageId}
    >
      {props.children}
    </Layout>
  )
}

export default BlogLayout
